import { useEffect, useState } from "react";
import Button from "../Button";
import ToolTip from "../ToolTip";

function AddButton({
  onClick,
  toolTip,
  openToolTip,
  toolMessage,
  show = false,
}) {
  const [showTooltip, setShowToolTip] = useState(false);

  useEffect(() => {
    setShowToolTip(openToolTip);
  }, [openToolTip]);

  return (
    <div
      className={`position-fixed bottom-0 end-0 m-4 ${show ? "d-block" : "d-none"}`}
    >
      <div className="position-relative">
        <button
          className="text-white shadow-sm bg-primary border-0"
          onClick={onClick}
          style={{
            width: "55px",
            height: "55px",
            borderRadius: "120px",
          }}
          onMouseEnter={() => {
            if (toolTip) {
              setShowToolTip(true);
            }
          }}
          onMouseLeave={() => setShowToolTip(false)}
        >
          <i className="bi bi-plus-lg fs-4" />
        </button>
      </div>

      {showTooltip && toolTip ? (
        <ToolTip message={toolMessage || "No Instruction"} />
      ) : (
        ""
      )}
    </div>
  );
}

export default AddButton;
